<template>
    <div id="affilates-components">

        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable title="Afiliado Dependiente">
            <print-card v-if="modalCard" v-show="modalCard" :sku="sku_card"></print-card>
            <form v-show="modalForm" id="formDep" class="animated fadeIn margin-al-inputs formDep">
                <div v-if="modificar">
                    <input type="hidden" name="currentName" v-model="affiliate.currentName">
                    <input type="hidden" name="currentEmail" v-model="affiliate.currentEmail">
                    <input type="hidden" name="currentUserName" v-model="affiliate.currentUserName">
                    <input type="hidden" name="currentPicture" v-model="affiliate.currentPicture">
                </div>
                <input type="hidden" name="titular_sku" v-model="affiliate.titular_sku">
                <div class="row">
                    <div class="col-12 col-md-3">
                        <div id="fotoUsuarioAdmin">
                            <img v-if="affiliate.picture" :src="'../storage/afiliados/dependientes/'+affiliate.picture"
                                 alt=""
                                 class="rounded-circle">
                            <img v-else :src="'../images/foto-usuario.jpg'" class="rounded-circle" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="fotoUploader">
                                <span class="btn btn-file">
                                    Imagen de Perfil <br> <i class="fas fa-upload"></i>
                                    <input type="file" data-label="avatar" name="picture" v-on:change="getLogo"
                                           placeholder="avatar">
                                </span>
                            <span class="label-file-papeleria alert alert-info logo"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <p class="fotoUploader">
                            Imagen o Logotipo, las imágenes serán escaladas a un tamaño de 300 &times; 300 px, en
                            formato y peso permitido de carga es: <br> <strong>.jpeg, .png, .jpg, .gif, .svg, con un
                            peso maximo de 3mb</strong>
                        </p>
                        <cite>
                            El correo asignado en este formulario se usara para iniciar sesión en el sistema.
                        </cite>
                    </div>
                </div>
                <hr>
                <h2 class="cabeza">Datos Generales</h2>
                <div class="row">

                    <div class="col-12 col-md-3">
                        <div class="client_sku">
                            TITULAR: <br>
                            <span> <strong>{{ affiliate.titular_sku }}</strong> </span>
                        </div>
                    </div>

                    <div class="col-12 col-md-3">
                        <input v-model="affiliate.sku" name="sku" id="sku" type="text"
                               class="al-inputs required codigo scr-input" placeholder="# afiliado GDL-XXXX-XXXX"/>
                        <label for="sku" class="scr-supertext"># afiliado GDL-XXXX-XXXX</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input v-model="affiliate.nombre" class="al-inputs required scr-input" type="text" name="nombre"
                               id="nomAfil" placeholder="Nombre">
                        <label for="nomAfil" class="scr-supertext">Nombre</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input v-model="affiliate.paterno" class="al-inputs required scr-input" type="text"
                               name="paterno" id="apePaternoAfil" placeholder="Apellido Paterno">
                        <label for="apePaternoAfil" class="scr-supertext">Apellido Paterno</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input v-model="affiliate.materno" class="al-inputs required scr-input" type="text"
                               name="materno" id="apeMaternoAfil" placeholder="Apellido Materno">
                        <label for="apeMaternoAfil" class="scr-supertext">Apellido Materno</label>
                    </div>
                    <div class="col-12 col-md-3">

                        <input v-model="affiliate.fechaNac" class="al-inputs inputDate scr-input" type="text"
                               name="fechaNac" id="fechaNacAfil" placeholder="Fecha Nacimiento">
                        <label for="fechaNacAfil" class="scr-supertext">Fecha Nacimiento</label>

                    </div>
                    <div class="col-12 col-md-3">

                        <select v-model="affiliate.sexo" data-select="on" name="sexo" class="required" id="sexoAfil">
                            <option :value="0">Selecciona un sexo</option>
                            <option :value="1">Femenino</option>
                            <option :value="2">Masculino</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <select id="estado" v-model="affiliate.estado" v-on:change="selectCities($event);"
                                data-name-input="Selecciona un estado" name="estado" data-select="on" class="required">
                            <option :value="0">Seleccione un Estado*</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">
                                {{ state.estado }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <select data-select="on" v-model="affiliate.ciudad" name="ciudad"
                                v-on:change="getSkuClient($event)" data-name-input="Selecciona una ciudad" id="ciudad"
                                class="required">
                            <option :value="0">Selecciona un Ciudad*</option>
                            <option v-for="city in cities" :value="city.cities_id" :key="city.cities_id"
                                    :data-abrv="city.abrv">
                                {{ city.ciudad }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <input v-model="affiliate.email" name="email" id="email" type="email"
                               class="al-inputs scr-input" placeholder="Correo" required/>
                        <label for="email" class="scr-supertext">Correo</label>
                    </div>

                </div>
                <h2 class="cabeza">Datos de Autenticación</h2>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <input id="username" name="username" type="text" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Usuario" v-model="affiliate.username"/>
                        <label for="username" class="scr-supertext">Usuario</label>
                        <cite v-if="modificar">
                            Este campo esta habilitado para hacer un cambio de usuario. La misma que se usa para iniciar
                            sesión.
                        </cite>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="pass" name="password" type="password" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Contraseña" v-model="affiliate.password"/>
                        <label for="pass" class="scr-supertext">Contraseña</label>
                        <cite v-if="modificar">
                            Este campo esta habilitado para hacer un cambio de contraseña. La misma que se usa para
                            iniciar sesión.
                        </cite>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Guardar
                        </button>
                    </div>
                </div>
            </form>

        </b-modal>

        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row ">
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                        <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                      v-model="pagination.current_page" :total-rows="pagination.total"
                                      :per-page="pagination.per_page" aria-controls="my-table"
                                      v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                        <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                               placeholder="Buscar por palabra">
                        <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                    </div>
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                        <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-2 mb-3 mb-sm-0">
                        <button type="button" class="formSubmit" v-b-modal.modal-serv
                                v-on:click="openModal();openModalsProviders();">Agregar
                        </button>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                             :items="pagination.data" :filter="filter">
                        <template #head(Acciones)="{item}">
                            <i class="fa-solid fa-gear"></i>
                        </template>
                        <!-- A virtual column -->
                        <template #cell(cliente)="{item}">
                            {{ item.nombre }} {{ item.paterno }} {{ item.materno }}
                        </template>
                        <template #cell(fecha_nacimiento)="{item}">
                            {{ item.fechaNac }}
                        </template>
                        <template #cell(titular_sku)="{item}">
                            {{ item.sku }}
                        </template>
                        <template #cell(Acciones)="{item}">
                            <div class="dropdown">
                                <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-cogs"></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="javascript:void(0)"
                                       v-on:click="modificar=true; updateReg(item)">Editar</a>
                                    <a class="dropdown-item" href="javascript:void(0)"
                                       v-on:click="sku_card=item.sku; openModalsProviders('card')">Imprimir Tarjeta</a>
                                    <a class="dropdown-item" href="javascript:void(0)"
                                       v-on:click="onClickDelete(item.id)">Borrar</a>
                                </div>
                            </div>
                        </template>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                            </div>
                        </template>
                    </b-table>
                    <div class="col-12 col-xl-2">
                        <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                      v-model="pagination.current_page" :total-rows="pagination.total"
                                      :per-page="pagination.per_page" aria-controls="my-table"
                                      v-on:change="onChange"></b-pagination>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {estadoService} from "../../Services/States.service";
import {statescitiesService} from "../../Services/Statescities.service";
import {affiliatedependentsService} from "../../Services/AffiliateDependents.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "affiliates",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        },
        titular_sku: {
            type: String,
            default: 0
        },
    },

    data() {
        return {
            showModal: false,
            show: false,
            isBusy: false,
            modificar: false,
            person: false,
            filter: null,
            affiliate: {
                id: 0,
                user_id: '',
                client_id: '',
                nombre: '',
                paterno: '',
                materno: '',
                fechaNac: '',
                colonia: '',
                calle: '',
                numInt: '',
                numExt: '',
                cp: '',
                estado: 0,
                ciudad: 0,
                sexo: 0,
                titular_sku: this.titular_sku,
                sku: '',
                picture: '',
                username: '',
                password: '',
                email: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentPicture: '',
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'cliente'},
                {key: 'fecha_nacimiento'},
                {key: 'titular_sku'},
                {key: 'Acciones'}
            ],
            params: {
                titular_sku: this.titular_sku,
                limit: 10,
                page: 1,
                where: [],
            },
            states: [],
            cities: [],
            tituloBtn: 'Agregar',
            kind_affiliate: 9,
            sku_card: '',
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await affiliatedependentsService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async openModal() {
            if (this.modificar === false) {
                await this.getSkuClient();
            }
            this.showModal = true;
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formDep');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formDep');
                if (this.modificar) {
                    resp = await affiliatedependentsService.updateOne(this.affiliate.id, formData, {isForm: true});
                } else {
                    resp = await affiliatedependentsService.saveOne(formData, {isForm: true});
                }
                this.modificar = false;
                this.showModal = false;
                this.getAlert(resp.process, '');
                await this.index();
                this.disableSubmitBtn(false);
            }
        },
        async index() {
            this.isBusy = true;
            this.affiliate.titular_sku = this.titular_sku;
            this.pagination = await affiliatedependentsService.getMany(this.params);
            this.states = await estadoService.getMany({limit: 0});
            this.isBusy = false;
        },
        async selectCities($e) {
            let state_id = this.stateId($e);
            this.cities = await statescitiesService.getCitiesByState(state_id);
        },
        async getSkuClient() {
            this.affiliate.sku = await affiliatedependentsService.getSkuClient(this.kind_affiliate, this.titular_sku);
        },
        changeInput(value) {
            switch (value) {
                case 1:
                    this.person = true;
                    break;
                default:
                    this.person = false;
                    break;
            }
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.tituloBtn = 'Actualizar';
                this.selectCities(data.estado);
                this.affiliate = data;
                this.affiliate.email = data.reluser.email;
                this.affiliate.estado = data.estado;
                this.affiliate.cuidad = data.ciudad;
                this.affiliate.currentName = data.nombre;
                this.affiliate.currentEmail = data.reluser.email;
                this.affiliate.currentUserName = data.reluser.username;
                this.affiliate.username = data.reluser.username
                this.affiliate.currentPicture = data.picture;
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
        setEmpty() {
            this.affiliate = {
                id: 0,
                user_id: '',
                client_id: '',
                nombre: '',
                paterno: '',
                materno: '',
                fechaNac: '',
                colonia: '',
                calle: '',
                numInt: '',
                numExt: '',
                cp: '',
                estado: 0,
                ciudad: 0,
                sexo: 0,
                titular_sku: this.titular_sku,
                sku: '',
                picture: '',
                banco: '',
                cuenta: '',
                clabe: '',
                medicamento: '',
                cant_disp: '',
                username: '',
                password: '',
                email: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentPicture: '',
            }
        }
    },
    mounted() {
        this.index();
    }
}
</script>

